<template>
	<div class="update-contract-info" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                   <div class="card-body">
                          <h4 class="mb-3">契約情報</h4>
                          <div>
                              <transition name="slide-fade">
                              <div class="alert alert-success" v-if="info" >{{ info }}</div>
                            </transition>
                            
                            <div class="form-group" v-bind:class="{  'text-danger has-error': errors.contract_company_name }">
                                  <label for="contract_company_name">会社名<span class="badge badge-required">必須</span></label>
                                  <input type="text" placeholder="例：株式会社パンタグラフ" v-model="contract_company_name" class="form-control" name="contract_company_name" id="personal_company_name" />
                                    <p v-for="(error,key) in errors.contract_company_name" :key="key" class="error-text" >{{error}}</p>
                              </div>
                              <div class="form-group">
                                  <label for="email">メールアドレス<span class="badge badge-required">必須</span></label>
                                  <input type="email" v-model="email" readonly class="form-control" name="email" id="email" />
                                   
                              </div>

                              <div class="form-group" v-bind:class="{  'text-danger has-error': errors.name }">
                                  <label for="name">名前<span class="badge badge-required">必須</span></label>
                                  <input type="text" placeholder="例：山田　太郎" v-model="name" class="form-control" name="name" id="name" />
                                    <p v-for="(error,key) in errors.name" :key="key" class="error-text" >{{error}}</p>
                              </div>
							             
                              <div class="form-group" v-bind:class="{  'text-danger has-error': errors.dept }">
                                  <label for="dept">部署<span class="badge badge-required">必須</span></label>
                                  <input type="text" placeholder="例：マーケティング部" v-model="dept" class="form-control" name="dept" id="dept" />
                                    <p v-for="(error,key) in errors.dept" :key="key" class="error-text" >{{error}}</p>
                              </div>
                              <div class="form-group" v-bind:class="{  'text-danger has-error': errors.designation }">
                                  <label for="designation">役職<span class="badge badge-option">任意</span></label>
                                  <input type="text" placeholder="例：部長" v-model="designation" class="form-control" name="designation" id="designation" />
                                    <p v-for="(error,key) in errors.designation" :key="key" class="error-text" >{{error}}</p>
                              </div>
                             <div class="form-group" v-bind:class="{  'text-danger has-error': errors.phone_no }">
                                  <label for="phone_no">電話番号<span class="badge badge-required">必須</span></label>
                                  <input type="text" placeholder="例：03-5464-1444" v-model="phone_no" class="form-control" name="phone_no" id="phone_no"/>
                                    <p v-for="(error,key) in errors.phone_no" :key="key" class="error-text" >{{error}}</p>
                              </div>

                              <div class="form-group" v-bind:class="{  'text-danger has-error': errors.address_1 }">
                                  <label for="address_1">住所<span class="badge badge-required">必須</span></label>
                                  <input type="text" placeholder="例：東京都渋谷区恵比寿西2-17-4 代官山ウェスト1F" v-model="address_1" class="form-control" name="address_1" id="address_1" />
                                    <p v-for="(error,key) in errors.address_1" :key="key" class="error-text" >{{error}}</p>
                              </div>

							 

							   
                

                              <div v-if="isInitialization" class="btn-wrap form-group text-center">
                                <button class="btn btn-primary btn-next-form" @click="save">サイト登録へ</button>
                              </div>
                              <div v-else class="btn-wrap form-group text-center">
                                <a class="btn btn-primary btn-white" :href="'/contract'">戻る</a>
                                <button  class="btn btn-primary" @click="save"  :disabled="loading" >更新</button>
                                <!-- <a class="btn btn-primary" :href="'/users/' + userDetails.id + '/edit' ">更新する</a> -->
                              </div>
                        </div>
					          </div>
                </div>
            </div>
			
		</div>
	</div>
</template>

<script>
 // import { Select, Option } from 'element-ui'
// import { ElSelect, ElOption } from "element-plus";
import { setupCache } from 'axios-cache-adapter';
import assert from 'assert'
export default {
  props: [ 'selectedUserData', 'companyInfo'],
  components: {
    
  //  [Select.name]: Select,
  //  [Option.name]: Option,
    },
	data() {
		return {
			// Our data object that holds the Laravel paginator data
      errors: {},
      company_info:{},
      user_id:null,
      designation: '',
      dept: '',
      phone_no: '',
      address_1: '',
      email:'',
      country: "JP",
      contract_company_name: '',
      name:'',
			siteId:0,
      loading: false,
      info:null,
      isInitialization:false
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
    const userData = JSON.parse(this.selectedUserData);
    this.company_info = JSON.parse(this.companyInfo);
    this.user_id = userData.id;
    this.designation = userData.designation;
    this.dept = userData.dept;
    this.phone_no = this.company_info.phone_no;
    this.phone_no = this.phone_no=='000-0000-0000' ? '' : this.phone_no;
    this.address_1 = (this.company_info.address_1).trim();
    this.email = userData.email;
    this.contract_company_name = this.company_info.contract_company_name;
    this.country = this.company_info.country ? this.company_info.country : "JP";
    this.name = userData.name;
    this.isInitialization = window.initial_setup ? window.initial_setup : false
	},

compute:{
},
watch: {
  
},
	methods: {
    validateEmail() {
      /*if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          this.msg['email'] = 'Please enter a valid email address';
      } else {
          this.msg['email'] = '';
      }*/
    },

		// Our method to GET results from a Laravel endpoint
		 save() {
      this.loading = true;
      this.isSend = 0;
      this.errors = {};
      axios.put(`/contract/${this.user_id}`, {
        "_method": "post",
        name : this.name,
        //email : this.email,
        dept : this.dept,
        designation: this.designation,
        contract_company_name: this.contract_company_name,
        //zip_code : this.zipcode,
        //state : this.state,
        //city : this.city,
        address_1 : this.address_1,
        phone_no : this.phone_no,
        country : this.country,
        is_validation: this.isInitialization ? 1 : 0
      	//reservation_at: moment(this.reservationDate).format('YYYY-MM-DD') + " "+this.reservationHour+":"+this.reservationMinute
      }).then(response => {
        this.loading = false;
        if(this.isInitialization ) {
          tempContractData = response.data.tempContractData;
          tempContractData['user_id'] = this.user_id;
          tempContractData['email'] = this.email;
          //this.$emit('tempContractData', response.data.tempContractData);
          //this.$emit('custom-event-name', tempContractData);
					window.stepperForm.next()
				} else {
        this.$toast(response.data.info, {
          toastClassName: "toaster"
        })
      }
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
           this.loading = false;
           //this.info = error.response.data.info
        } else if (error.response.status === 419) {
          alert("ページセッション切りましたので、更新できませんでした。ページをリロードしてください")
        }
      });
    },
	}

}
</script>

<style >

.update-contract-info .form-group select {
  padding: 1rem;
  min-width: 280px;
  margin-bottom:10px;
}

.update-contract-info .input-group {
  max-width: 600px;
}
</style>